module.exports = __webpack_public_path__ + "static/img/en.78759bc5.png";